var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBodyFoot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.9609 77.2617C91.0294 68.7273 88.3922 68.7437 87.7441 57.373C87.0961 46.0024 85.6445 31.4453 68.9453 31.4453C61.3281 31.4453 51.3144 35.8611 50.7324 52.0508C48.6816 66.1133 35.8887 70.166 28.4026 73.3438C25.9245 74.3957 21.6645 76.3672 19.1895 76.3672C17.7246 76.3672 16.7266 75.4082 15.0391 75.4395C8.98438 75.4395 6.39648 81.0547 6.39648 85.0586C6.39648 89.0625 9.11849 93.5117 15.3713 93.5117C19.6843 93.5117 71.2082 93.5117 80.6172 93.5117C90.0261 93.5117 94.8924 85.7962 92.9609 77.2617Z",
    fill: "#FFC83D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8516 71.875C67.3828 71.875 65.8529 66.0156 65.5273 62.5C65.5273 61.1328 64.6875 59.2773 62.5 59.2773C60.3125 59.2773 59.5215 60.791 59.5215 62.1582C59.5215 67.1387 62.0117 75 72.8516 75C77.8809 75 80.9082 72.4121 81.4453 69.3359C80.5176 70.2637 78.3203 71.875 72.8516 71.875Z",
    fill: "#D67D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2189 90.5762H8.35522C9.8103 92.3019 12.1108 93.5117 15.3715 93.5117H80.6173C84.1744 93.5117 87.0822 92.409 89.2189 90.5762Z",
    fill: "#D67D00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyFoot);
export default __webpack_public_path__ + "static/media/body_foot.01e3a524264406c23acde481a6caba90.svg";
export { ForwardRef as ReactComponent };